import { SuggestedFaqDetailsContainer } from '@/modules/SuggestedFaqDetails';

export const SuggestedFaqDetails = (): JSX.Element => <SuggestedFaqDetailsContainer />;

export default SuggestedFaqDetails;
